import { Component, OnInit } from '@angular/core';
import { AppointmentsCardService } from 'src/app/services/appointments-card.service';
import * as Constants from '../../.././models/Constants';

@Component({
  selector: 'app-appointments-card',
  templateUrl: './appointments-card.component.html',
  styleUrls: ['./appointments-card.component.scss']
})
export class AppointmentsCardComponent implements OnInit {

  constructor(public appointmentsCardService: AppointmentsCardService) { }

  ngOnInit(): void {
  }


  public iconConfig = {
    iconName: 'arrow-right',
    iconType: 'fal',
    iconPlacement: 'right',
  };

  loaderType = Constants.LOADER_TYPE.CARD;

  /**
   * 
   * @param selectedLink 
   * This method is used to open the selected appointment link.
   */
  goToMyAppointments(selectedLink) {
    this.appointmentsCardService.isDbMyApppointmentsErrorEnabled = false;
    this.appointmentsCardService.hasNoDbMyApppointmentsData = false;
    if (selectedLink && selectedLink?.actionCode == "LINK_ACTION") {
      this.appointmentsCardService.openSelectedLink(selectedLink, false);
    } else {
      //  console.log('action code is not link action');
      this.appointmentsCardService.isDbMyApppointmentsErrorEnabled = true;
    }
  }


  closeWarning() {
    this.appointmentsCardService.isDbMyApppointmentsErrorEnabled = false;
    this.appointmentsCardService.hasNoDbMyApppointmentsData = false;
  }


  ngOnDestroy() {
    clearTimeout(this.appointmentsCardService.dbMyApppointmentsloaderTimeoutId);
  }

}
